const formatters = new Map<number, Intl.NumberFormat>();

const getFormatter = (decimals: number): Intl.NumberFormat => {
  let formatter = formatters.get(decimals);
  if (!formatter) {
    formatter = new Intl.NumberFormat('nl-NL', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
    formatters.set(decimals, formatter);
  }
  return formatter;
};

export const displayWithDecimals =
  (decimals: number) =>
  (value: number): string | number => {
    if (isNaN(value)) return value;
    return getFormatter(decimals).format(value);
  };
